import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { headData } from "@/lib/seo";
import { useServiceInfo } from "@/lib/serviceInfo";

function upsert(selector, tag, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

export function Seo() {
  const { pathname } = useLocation();
  const info = useServiceInfo();
  useEffect(() => {
    if (pathname.startsWith("/admin")) {
      upsert('meta[data-seo="robots"]', "meta", { name: "robots", content: "noindex,nofollow", "data-seo": "robots" });
      return;
    }
    const d = headData(pathname, info);
    document.title = d.title;
    upsert('meta[name="description"]', "meta", { name: "description", content: d.description });
    upsert('meta[data-seo="robots"]', "meta", { name: "robots", content: d.robots, "data-seo": "robots" });
    upsert('link[rel="canonical"]', "link", { rel: "canonical", href: d.canonical });
    upsert('meta[property="og:title"]', "meta", { property: "og:title", content: d.title });
    upsert('meta[property="og:description"]', "meta", { property: "og:description", content: d.description });
    upsert('meta[property="og:url"]', "meta", { property: "og:url", content: d.canonical });
    const ld = upsert("script#ld-json", "script", { type: "application/ld+json", id: "ld-json" });
    ld.textContent = JSON.stringify(d.jsonld);
  }, [pathname, info]);
  return null;
}
